import React from 'react';
import AuthInformer from 'modules/auth/components/AuthInformer';
import { useSelector } from 'react-redux';
import { getHub } from 'components/App/selectors';
import { getFirstAvailableHub, getHubByRoutingHub } from 'helpers/hubs';
const AuthInformerContainer = () => {
  const routingHub = useSelector(getHub);
  const currentHub = getHubByRoutingHub(routingHub) || getFirstAvailableHub();
  return <AuthInformer hub={currentHub.KEY} />;
};
export default AuthInformerContainer;
